<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col">
            <h4 class="text-body">#{{ order.shopify_order_number }}</h4>
          </div>          
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card grmt-7 grmb-7 p-3">
              <h3 class="mt-3">Order</h3>
              <table class="table table-sm">
                <tr>
                  <td>ID</td>
                  <td>{{ order.shopify_order_id }}</td>
                </tr>
                <tr>
                  <td>Order Number</td>
                  <td>{{ order.shopify_order_number }}</td>
                </tr>
              
                 <tr>
                  <td>Requested Amount</td>
                  <td>
                  {{ order.requested_amount }}
                  </td>
                </tr>
             
                <tr>
                  <td>Paid</td>
                  <td>
                    <i
                      class="lni lni-checkmark-circle text-success"
                      v-if="order.is_paid == 1"
                    ></i>
                  </td>
                </tr>
                <tr>
                  <td>Fulfilled</td>
                  <td>
                    <i
                      class="lni lni-checkmark-circle text-success"
                      v-if="order.is_fulfilled == 1"
                    ></i>
                  </td>
                </tr>
                <tr>
                  <td>Had failure</td>
                  <td>
                    <i
                      class="lni lni-checkmark-circle text-danger"
                      v-if="order.had_failure == 1"
                    ></i>
                  </td>
                </tr>
            
              </table>
            </div>

            <div class="card grmt-7 grmb-7 p-3">
              <h3 class="mt-3">Event Log</h3>
              <table class="table table-sm">
                <thead>
                  <th>Event</th>
                  <th>Publisher</th>
                  <th>Time</th>
                </thead>

                <tr v-for="event in order.order_events" :key="event.id">
                  <td>{{ event.event }}</td>
                  <td>{{ event.publisher }}</td>
                  <td>
                    {{
                      moment(new Date(event.created_at)).format(
                        "DD MMM YYYY, HH:mm:ss"
                      )
                    }}
                  </td>
                </tr>
              </table>
            </div>


            <div class="card grmt-7 grmb-7 p-3">
              <h3 class="mt-3">Order</h3>
              <pre class="text-body">{{ order.order | pretty }}</pre>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import orderRepo from "@/api/repos/orderRepo";
var JSONbig = require("json-bigint");

export default {
  props: ["id"],

  filters: {
    pretty: function (value) {
      return JSON.stringify(JSONbig.parse(value), null, 2);
    },
  },

  mounted() {
    this.getOrder();
  },

  data() {
    return {
      loading: true,
      order: {},
    };
  },

  methods: {
    async getOrder() {
      try {
        let { data } = await orderRepo.get(this.id);
        this.order = data.order;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async sendToSage(id) {
      this.loading = true;
      try {
        await orderRepo.sendToSage(id);
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          this.getOrder();
        }, 5000);
      }
    },
  },
};
</script>
